module.exports = __webpack_public_path__ + "img/tags-svgrepo-com.9538ebf5.svg";